<!--suppress UnnecessaryLabelJS -->
<template>
	<v-data-table
		:headers="headers"
		:items="organizations"
		:loading="loading"
		class="elevation-1"
	>
		<v-progress-linear
			slot="progress"
			color="blue"
			indeterminate
		/>
		<template #item="{item}">
			<organization-row
				:key="item.id"
				:organization="item"
				@edit="onEdit"
			/>
		</template>
	</v-data-table>
</template>

<script>
import OrganizationRow from "src/view/organizations/OrganizationRow";
import { types } from "src/store/modules/Organization.module";
import FilterAble from "src/mixins/FilterAble";

export default {
	name: "OrganizationsTable",
	components: {
		OrganizationRow,
	},
	props: [],
	mixins: [new FilterAble(types)],
	data () {
		return {
			loading: false,
			headers: [
				{ text: "ארגון", value: "name" },
				{ text: "style", value: "style" },
				{ text: "domain", value: "domain" },
				// {text: "view", value: "view"},
				{ text: "מציג עדכונים", value: "show_updates" },
				{ text: "אפשר הרשמה מבחוץ", value: "out_register" },
				{ text: "מחיר הרשמה", value: "price" },
				{ text: "משימות", value: "name" },

			],
			search: null,
			showDialog: false,
		};
	},
	computed: {
		organizations () {
			return this.$store.state.OrganizationModule.organizations;
		},
	},
	methods: {
		onEdit (Organization) {
			this.$emit("edit", Organization);
		},
	},
};
</script>

<style>

</style>
